module.exports = __webpack_public_path__ + "img/failesucee.f3557a8a.png";